import React from 'react';
import FeatureCards from "../../components/FeatureCards/FeatureCards";
import CTA from "../../components/Constant/cta/CTA";
import TimelineSection from "../../components/TimelineSection/TimelineSection";
import WhySection from "../../components/WhySection/WhySection";
import LocationTimeline from "../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../components/IntroSection/IntroSection";
import FAQList from "../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../components/ServiceCards/ServiceCards ";

export default function MaritimeShippingLicensesPanama() {

    return (
        <main className='main'>
            <IntroSection
                title="Maritime & Shipping Licenses – Panama"
                subtitle="Operate Under the World’s Largest Shipping Registry"
                description="Panama is the global leader in maritime and shipping services, home to the largest ship registry in the world. Over 8,000 vessels operate under the Panama flag, benefiting from cost efficiency, global recognition, and favorable tax treatment. The Panama Maritime Authority (AMP) issues licenses for ship registration, shipping companies, and maritime services, making Panama the #1 choice for global shipping operators."
                badges={[
                    "Ship Registration",
                    "Maritime Company Licensing",
                    "Ship Mortgages",
                    "Crew & Offshore Services"
                ]}
                buttonText="Request a Panama Shipping Proposal →"
                buttonLink="/quote"
                imageSrc={require('../../assets/images/services/panama-shipping.png')}
                imageAlt="Panama Maritime & Shipping Licensing"
            />


            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose Panama for Shipping?'
                        blocks={[
                            {
                                items: [
                                    {
                                        title: "World’s Largest Shipping Registry",
                                        text: "Panama represents over 16% of global tonnage."
                                    },
                                    {
                                        title: "Favorable Regulations",
                                        text: "Open registry system operating since 1917."
                                    },
                                    {
                                        title: "Tax & Cost Advantages",
                                        text: "Territorial tax regime with low registration and operational fees."
                                    },
                                    {
                                        title: "Global Recognition",
                                        text: "Respected by IMO, WTO, and major international ports."
                                    },
                                    {
                                        title: "Flexible Ownership",
                                        text: "Ships can be owned by Panamanian or foreign entities."
                                    }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Types of Shipping & Maritime Licenses in Panama"
                        blocks={[
                            {
                                title: "Ship Registration (Panama Flag)",
                                items: [
                                    { text: "Open to Panamanian and foreign owners." },
                                    { text: "Covers commercial vessels, yachts, fishing vessels, and offshore rigs." },
                                    { text: "Provisional Registration: valid for 6 months." },
                                    { text: "Permanent Registration: issued after document verification." }
                                ]
                            },
                            {
                                title: "Shipping Company License",
                                items: [
                                    { text: "Allows operation of shipping lines and vessel management." },
                                    { text: "Used for freight companies, charters, and maritime logistics operators." }
                                ]
                            },
                            {
                                title: "Ship Mortgage & Financing",
                                items: [
                                    { text: "Panama allows registration of vessel mortgages." },
                                    { text: "Recognized by international lenders and investors." }
                                ]
                            },
                            {
                                title: "Maritime Services Licensing",
                                items: [
                                    { text: "Includes crew management, manning agencies, technical services, port operators." },
                                    { text: "All overseen and regulated by the Panama Maritime Authority (AMP)." }
                                ]
                            }
                        ]}
                    />

                    <LocationTimeline
                        title="Capital & Requirements"
                        item={[
                            {
                                title: "Ship Registration",
                                text: "No minimum capital; requires valid tonnage, safety, and ownership certificates."
                            },
                            {
                                title: "Shipping Company License",
                                text: "Requires incorporation of a Panamanian entity."
                            },
                            {
                                title: "Ship Mortgages",
                                text: "Requires vessel valuation and mortgage registration with AMP."
                            },
                            {
                                title: "Crew Agencies",
                                text: "Need AMP licensing and compliance with maritime labor rules."
                            }
                        ]}
                    />

                    <ServiceCards
                        title='Benefits of a Panama Maritime License'
                        services={[
                            {
                                title: "Global Recognition",
                                text: "Panama flag is accepted worldwide across all major ports."
                            },
                            {
                                title: "Financing Access",
                                text: "Ship mortgages under Panama law are enforceable internationally."
                            },
                            {
                                title: "Flexibility",
                                text: "Ships can be registered regardless of the owner's nationality."
                            },
                            {
                                title: "Cost-Effective",
                                text: "Lower fees than many EU shipping registries."
                            },
                            {
                                title: "Strategic Hub",
                                text: "Panama Canal connects Atlantic and Pacific trade routes."
                            }
                        ]}
                    />

                    <FeatureCards
                        title='Licensing & Registration Process'
                        features={[
                            {
                                title: "Pre-Application Consultation",
                                text: "Select ship registration, company license, or maritime service permit."
                            },
                            {
                                title: "Company Incorporation",
                                text: "Form a Panamanian entity if required by license type."
                            },
                            {
                                title: "Application Submission",
                                text: "Submit tonnage certificate, ownership proof, and compliance documents."
                            },
                            {
                                title: "Provisional License / Flag Issuance",
                                text: "A provisional flag or license valid for 6 months is issued."
                            },
                            {
                                title: "Permanent Registration or Approval",
                                text: "Final approval typically takes 3–6 months."
                            }
                        ]}
                    />

                    <TimelineSection
                        title='Timeline & Costs'
                        items={[
                            {
                                name: "Timeline",
                                duration: "2–6 months."
                            },
                            {
                                name: "Setup Costs",
                                description: "from USD 20,000+ (ship registration and licensing)."
                            },
                            {
                                name: "Annual Costs",
                                description: "Registry fees, AMP supervision, and crew compliance."
                            }
                        ]}
                    />

                    <DetailsSection
                        title='Why Offshore Advisory'
                        items={
                            [
                                { text: "Specialists in Panama ship registration and maritime licensing" },
                                { text: "End-to-end support: vessel flagging, company setup, AMP licensing" },
                                { text: "Introductions to shipping financiers, insurers, and port operators" },
                                { text: "Guidance on compliance with IMO standards" },
                                { text: "Global comparison: Panama vs Marshall Islands vs Liberia registries" }
                            ]
                        }
                        />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Looking to register vessels or establish a shipping company in Panama?"
                        description="Panama offers the world’s largest ship registry, competitive costs, and global recognition — making it the top choice for international shipping operations."
                        buttonText="Book a Panama Shipping Consultation →"
                        buttonLink="/quote"
                    />


                </div>
            </section>
        </main>
    );
};

const testimonialsData = [
    {
        quote: "We flagged our commercial vessels in Panama with Offshore Advisory. The process was fast and internationally recognized.",
        author: "Alejandro M.",
        role: "Shipping Company CEO"
    },
    {
        quote: "Panama ship registry gave us global access and easier financing for our fleet.",
        author: "Sofia R.",
        role: "Maritime Investor"
    }
];

const faqData = [
    {
        question: "Why is Panama the largest ship registry?",
        answer: "Because of its open registry system, cost advantages, and global recognition."
    },
    {
        question: "Can foreigners register ships under Panama flag?",
        answer: "Yes — ship ownership is open to all nationalities."
    },
    {
        question: "How long does ship registration take?",
        answer: "Provisional registration: 48 hours. Permanent: 3–6 months."
    },
    {
        question: "Are ship mortgages recognized globally?",
        answer: "Yes — Panama ship mortgages are widely used in international financing."
    },
    {
        question: "Is Panama registry compliant with IMO rules?",
        answer: "Yes — Panama adheres to IMO conventions and safety standards."
    }
];
